import { styled } from '@fluentui/utilities';
import { DatePickerBase } from './DatePicker.base';
import { styles } from './DatePicker.styles';
export var DatePicker = styled(DatePickerBase, styles, undefined, {
    scope: 'DatePicker',
});
//# sourceMappingURL=DatePicker.js.map